export const SCENARIOS_WITH_NO_DEFAULT_BRANDING_PLACEMENTS = ['error']

// Steps rendering their own full page chrome (header, background, footer)
export const STEPS_WITH_FULL_PAGE_LAYOUT = [
  'AddressUploadAmexGreat',
  'GeneralConditionsAmexGreat',
  'UserDataAmexGreat',
  'SignDocumentAmexGreat',
  'DocumentTypeAmexGreat',
  'PlaceOfBirthAmexGreat',
  'VideoOnboardingAmexGreat',
  'VideoIdAmexGreat',
  'EidAmexGreat',
  'ReadIdAmexGreat',
  'ReadIdCompletedAmexGreat',
  'WalletVerificationAmexGreat',
]

export const STEPS_WITHOUT_TOP_BAR = [
  'SignDocument',
  'SignDocumentEnpal',
  'SignDocumentOnventis',
  'EasySignDocument',
  ...STEPS_WITH_FULL_PAGE_LAYOUT,
]

export const STEPS_WITHOUT_TOP_BAR_MOBILE = ['VideoId', 'EnrollmentVideoId', 'VideoIdEnpal']

export const STEPS_WITH_NO_DEFAULT_BRANDING_PLACEMENTS = [
  'Onfido',
  'SignDocumentEnpal',
  'SignDocumentSantander',
  'SignDocumentOnventis',
  'EasySignDocument',
  ...STEPS_WITH_FULL_PAGE_LAYOUT,
]

export const STEPS_WITH_100_PERCENT_BRANDING = [
  'SignDocumentEnpal',
  'SignDocumentOnventis',
  'EasySignDocument',
]

export const STEPS_WITH_1000_PX_BRANDING = ['VideoId', 'EnrollmentVideoId', 'VideoIdEnpal']

export const STEPS_WITH_940_PX_BRANDING = [
  'SignDocument',
  'SignDocumentIkano',
  'SignDocumentSantander',
  'SignDocumentBmw',
  'EnrollmentAcceptCertificate',
]

export const STEPS_WITH_500_PX_BRANDING = ['MicropaymentInfoAmexPage', 'MicropaymentFintecAmexPage']
